// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Headline } from "#/components/headline/Headline";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    Headline,
  },
})
export class PiDetailsWidget extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  get productLink() {
    if (this.instance["product_link_href"]) {
      return this.instance["product_link_href"]["href"];
    } else {
      return null;
    }
  }

  get abhLink() {
    if (this.instance["abh_link_href"]) {
      return this.instance["abh_link_href"]["href"];
    } else {
      return null;
    }
  }

  get mediaAlignmentClass() {
    if (this.instance["layout"] == "text_first") {
      return "pi-details-widget--image-right";
    } else {
      return "pi-details-widget--image-left";
    }
  }
}
